<template>
  <div class="banner-wrapper">
    <h1 v-if="title" data-test="header">{{ $t(title) }}</h1>
    <div class="banner-inner-wrapper">
      <div
        v-if="imagePath"
        class="hero-character-cropped"
        v-bind:style="{ 'background-image': 'url(' + imagePath + ')' }"
      ></div>
      <SpeechBubble v-if="message" class="banner-bubble">
        <span v-html="message"></span>
      </SpeechBubble>
    </div>
  </div>
</template>

<script setup lang="ts">
import SpeechBubble from "@/components/Common/SpeechBubble/SpeechBubble.vue";
import { defineProps, withDefaults } from "vue";

interface Props {
  message?: string;
  imagePath?: string;
  title?: string;
  imageWidthDesktop?: string;
  imageHeightDesktop?: string;
  imageMarginLeftDesktop?: string;
  imageWidthMobile?: string;
  imageHeightMobile?: string;
  imageMarginLeftMobile?: string;
}

withDefaults(defineProps<Props>(), {
  imagePath: null,
  title: null,
  imageWidthDesktop: "170px",
  imageHeightDesktop: "250px",
  imageMarginLeftDesktop: "30px",
  imageWidthMobile: "190px",
  imageHeightMobile: "300px",
  imageMarginLeftMobile: "-5px",
});
</script>

<style lang="scss" scoped>
@import "@/common/theme/breakpoints.scss";

.banner-wrapper {
  background: var(--ion-color-primary-banner-bg);
  height: fit-content;
  position: relative;
  border-radius: 0px 0px 24px 24px;
  padding-top: 24px;
  display: relative;
  overflow: hidden;
}

.banner-inner-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  min-height: 208px;
}

h1 {
  font-family: Roboto;
  font-size: 36px;
  line-height: 36px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: -0.25px;
  margin: 0;
  text-align: left;
  padding-left: 24px;
}
.banner-bubble {
  width: 140px;
  min-width: 140px;
  max-width: 250px;
  margin: 25px 50px 24px 120px;
  box-shadow: 4px 4px 0px 0px var(--ion-color-primary-bubble-shade);
}

.banner-bubble-container {
  min-width: 160px;
  max-width: 233px;
  margin: 20px 0 0 -50px;
}

.hero-character-cropped {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
  position: absolute;
  -webkit-clip-path: polygon(0 0, 100% 0, 100% 87%, 0% 100%);
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 100%);
  top: 70px;
  width: v-bind(imageWidthMobile);
  height: v-bind(imageHeightMobile);
  margin-left: v-bind(imageMarginLeftMobile);
}

@include breakpoint(xsmall) {
  .banner-bubble {
    width: 210px;
    margin-left: 130px;
  }
}

@include breakpoint(small) {
  .banner-bubble {
    width: 230px;
  }

  h1 {
    padding-left: 36px;
  }
}

/* Desktop */
@include breakpoint(medium) {
  .banner-wrapper {
    display: flex;
    flex-direction: column;
    border-radius: 0px 0px 48px 48px;
    padding-top: 84px;
  }

  h1 {
    font-size: 45px;
    line-height: 45px;
    margin-left: 7px;
  }

  .banner-bubble {
    width: calc(100% - 220px);
    max-width: 360px;
    margin-left: 170px;
  }
  .hero-character-cropped {
    top: 135px;
    width: v-bind(imageWidthDesktop);
    height: v-bind(imageHeightDesktop);
    margin-left: v-bind(imageMarginLeftDesktop);
  }
}
</style>
